<template>
  <v-container id="delivery-detail">
    <c-card class="white">
      <v-row class="mb-2" justify="center" align="center">
        <v-icon size="40" color="blue">check_circle</v-icon>
        <div class="title ml-3">{{$route.name}}</div>
      </v-row>
      <fixed-delivery-detail :delivery-info="deliveryInfo" :customer-info="customerInfo"></fixed-delivery-detail>

      <div class="ml-3">
        <v-divider></v-divider>
        <v-row>
          <v-col cols="12" sm="6" md="2">
            <span class="font-weight-black">배송 진행 상황</span>
          </v-col>
          <v-col cols="12" sm="6" md="10">
            <v-chip color="light1Red" dark>
              {{deliveryInfo.state ? deliveryInfo.state.configName : '-'}}
            </v-chip>
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <span class="font-weight-black">배정 기사</span>
          </v-col>
          <v-col cols="12" sm="6" md="10">
            {{deliveryInfo.driverName ? deliveryInfo.driverName : '-'}}
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <span class="font-weight-black">배정 차량</span>
          </v-col>
          <v-col cols="12" sm="6" md="10">
            {{deliveryInfo.plateNo ? deliveryInfo.plateNo : '-'}}
          </v-col>
        </v-row>

        <v-divider></v-divider>
        <v-row>
          <v-col cols="12" sm="6" md="2">
            <span class="font-weight-black">배차 방식</span>
          </v-col>
          <v-col cols="12" sm="6" md="10">
            수동배차
          </v-col>
        </v-row>
      </div>
    </c-card>

    <v-row align="center">
      <v-col class="d-flex justify-center">
        <c-btn outlined class="mx-2" @click="$router.push('/deliveryReception')">처음으로</c-btn>
        <c-btn dark color="blue" class="mx-2" @click="manualDialogOpen=true">수동배차</c-btn>
      </v-col>
    </v-row>

    <manual-delivery-dialog
        :open.sync="manualDialogOpen"
        :delivery-check-data.sync="deliveryInfo"
        :deliveryFlag.sync="isDone"
    ></manual-delivery-dialog>
  </v-container>
</template>

<script>
import FixedDeliveryDetail from "@/views/CallTaxi/Delivery/FixedDeliveryDetail";
import ManualDeliveryDialog from "@/views/CallTaxi/Delivery/ManualDeliveryDialog";

export default {
  name: "DeliveryDetail",
  components:{FixedDeliveryDetail, ManualDeliveryDialog},
  data() {
    return {
      deliveryInfo : null,
      customerInfo : null,
      manualDialogOpen:false,
      isDone:null,
    }
  },
  mounted() {
    this.getDetailInfo();
  },
  methods:{
    async getDetailInfo() {
      const res = await this.$api.getDetailInfo(this.$route.params.id);
      this.deliveryInfo = res.data;
      this.customerInfo = res.data.customerDetailRes;
    }
  },
  watch: {
    isDone(value) {
      if(value && value === 'success') {
        this.$router.push(`/delivery/${this.$route.params.id}`);
      }
    }
  }
}
</script>

<style scoped>

</style>